import ArchPropertiesPane from '../_ARCH/ArchPropertiesPane.jsx'

export default function PropertiesPaneAa(props) {
    return (
        <ArchPropertiesPane
            {...props}
        />
    )
}
